import { render, staticRenderFns } from "./syOut.vue?vue&type=template&id=198c3994&scoped=true&"
import script from "./syOut.vue?vue&type=script&lang=js&"
export * from "./syOut.vue?vue&type=script&lang=js&"
import style0 from "./syOut.vue?vue&type=style&index=0&id=198c3994&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c3994",
  null
  
)

export default component.exports